export default __webpack_public_path__ + "static/media/23.5556e7a2.jpg";